import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import Href from '@sdk/components/ui/Href';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import { NoOverflowContainer } from '@web/timeClock/modals/rows/TasksRow/tasksRow.styles';
import TasksIconSvg from '@web/assets/svg/Icons/32/task-gray.svg';

type Props = {
  taskInstances: Array<{
    id: number;
    title: string;
  }>;
  onTaskPreview: (props: { taskInstance: any }) => void;
};

const TasksRow = ({ taskInstances, onTaskPreview }: Props) => {
  if (!taskInstances?.length) {
    return null;
  }

  return (
    <ModalRow label={gettext('Tasks')} icon={TasksIconSvg}>
      <NoOverflowContainer>
        {taskInstances.map((taskInstance, index) => (
          <span key={taskInstance.id}>
            <Href
              className="ignore-white-important"
              fontSize={14}
              themeColor={ThemeColorType.gray}
              hoverThemeColor={ThemeColorType.primary}
              onClick={() => onTaskPreview({ taskInstance })}>
              {taskInstance.title}
            </Href>
            {index !== taskInstances.length - 1 && (
              <Text14 themeColor={ThemeColorType.gray}>&nbsp;•&nbsp;</Text14>
            )}
          </span>
        ))}
      </NoOverflowContainer>
    </ModalRow>
  );
};

export default TasksRow;
